// @ vendor
const { merge } = require('lodash');

// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ utilities
const { isSafari } = require('../../insuranceUtilities/browserHelper');

// @ constants
const { FOURTH_STEP } = require('constants/index');
const { API_FLOW_STEPS } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_RELATED_PRICING_REQUEST,
    INSURANCE_REQUEST_RELATED_PRICING_SUCCESS,
    INSURANCE_REQUEST_RELATED_PRICING_FAILURE,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_REQUEST,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_SUCCESS,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_FAILURE
} = require('../../insuranceConstants/actionTypes');

const requestInsuranceRelatedPricingInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_PRICING_REQUEST
});

const requestInsuranceRelatedPricingSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_PRICING_SUCCESS,
    data
});

const requestInsuranceRelatedPricingFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_PRICING_FAILURE,
    data: { error }
});

const getPaymentAccountRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_REQUEST
});

const getPaymentAccountSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_SUCCESS,
    data
});

const getPaymentAccountFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_FAILURE,
    data: { error }
});

const setPaymentAccountRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_REQUEST
});

const setPaymentAccountSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_SUCCESS
});

const setPaymentAccountFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_FAILURE,
    data: { error }
});

const saveStepRequest = step => ({
    type: INSURANCE_REQUEST_RELATED_SAVE_STEP_REQUEST,
    data: { step }
});

const saveStepSuccess = step => ({
    type: INSURANCE_REQUEST_RELATED_SAVE_STEP_SUCCESS,
    data: { step }
});

const saveStepFailure = (step, error) => ({
    type: INSURANCE_REQUEST_RELATED_SAVE_STEP_FAILURE,
    data: { step, error }
});

const getPaymentAccount = () => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedState.get('data');

    if (currentState.get('id')) {
        dispatch(getPaymentAccountRequest());

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestPayment', { id: currentState.get('id') })
        )
            .then(response => {
                dispatch(getPaymentAccountSuccess(response.data));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(getPaymentAccountFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

const requestInsuranceRelatedCurrentPricing = insuranceId => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState;

    if (!currentState.get('isFetchingPricing')) {
        dispatch(requestInsuranceRelatedPricingInProgress());

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestPricingDiscount', { id: insuranceId })
        )
            .then(response => {
                dispatch(requestInsuranceRelatedPricingSuccess(response.data));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceRelatedPricingFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const saveStep = step => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedState.get('data');
    const appraisalProperty = getState().insuranceRequestRelatedState.getIn(['appraisal', 'property'])
    const immStep = getState().insuranceRequestRelatedWizard.getIn(['steps', step]);

    let uiStep = API_FLOW_STEPS.STEP_4;
    if (isSafari()) {
        uiStep = API_FLOW_STEPS.STEP_5;
    }

    const newState = {
        flowData: { uiStep },
        home: {
            number: appraisalProperty.get('streetNumber'),
            population: immStep.get('population'),
            road: appraisalProperty.get('street')
        },
        payment: {
            paymentType: immStep.get('paymentType')
        },
        startDate: null
    }

    const requestData = {
        query: merge({}, currentState.toJS(), newState)
    };

    dispatch(saveStepRequest(step));

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestStateRequest', { id: currentState.get('id') }),
        requestData
    )
        .then(() => dispatch(saveStepSuccess(step)))
        .catch(response => {
            if (!!response.error) {
                dispatch(saveStepFailure(step, response.error));
            } else {
                throw response;
            }
        });
};

const setPaymentAccount = () => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedState.get('data');
    const immStep = getState().insuranceRequestRelatedWizard.getIn(['steps', FOURTH_STEP]);

    const requestData = {
        query: {
            account: immStep.get('accountIBAN')
        }
    };

    dispatch(setPaymentAccountRequest());

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestPayment', { id: currentState.get('id') }),
        requestData
    )
        .then(() => {
            dispatch(setPaymentAccountSuccess());
            saveStep(FOURTH_STEP)(dispatch, getState);
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setPaymentAccountFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getPaymentAccount,
    setPaymentAccount,
    requestInsuranceRelatedCurrentPricing,
    saveStep
};
